
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Image, Video, Mic, FileCheck, Copy, UserCheck } from "lucide-react";

interface ActivityItem {
  type: string;
  name: string;
  status: string;
  time: string;
}

interface RecentActivityProps {
  activities: ActivityItem[];
}

const RecentActivity = ({ activities }: RecentActivityProps) => {
  const getStatusColor = (status: string) => {
    switch (status) {
      case "safe":
        return "text-green-600 bg-green-100 dark:bg-green-900/30";
      case "suspicious":
        return "text-yellow-600 bg-yellow-100 dark:bg-yellow-900/30";
      case "fraudulent":
        return "text-red-600 bg-red-100 dark:bg-red-900/30";
      default:
        return "text-gray-600 bg-gray-100";
    }
  };

  const getIconComponent = (type: string) => {
    switch(type) {
      case "Text": return FileText;
      case "Image": return Image;
      case "Video": return Video;
      case "Voice": return Mic;
      case "Document": return FileCheck;
      case "Plagiarism": return Copy;
      default: return UserCheck;
    }
  };

  return (
    <Card>
      <CardHeader>
        <div className="flex items-center justify-between">
          <div>
            <CardTitle>Recent Activity</CardTitle>
            <CardDescription>Your latest analysis results</CardDescription>
          </div>
          <Button variant="outline" size="sm">
            View All
          </Button>
        </div>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {activities.map((item, i) => {
            const IconComponent = getIconComponent(item.type);
            
            return (
              <div key={i} className="flex items-center">
                <div className="mr-4 p-2 rounded-full bg-muted">
                  <IconComponent className="h-5 w-5" />
                </div>
                <div className="flex-1 space-y-1">
                  <p className="text-sm font-medium leading-none">
                    {item.name}
                  </p>
                  <p className="text-xs text-muted-foreground">
                    {item.type} Analysis • {item.time}
                  </p>
                </div>
                <div className={`px-2.5 py-0.5 rounded-full text-xs font-medium ${getStatusColor(item.status)}`}>
                  {item.status}
                </div>
              </div>
            );
          })}
        </div>
      </CardContent>
    </Card>
  );
};

export default RecentActivity;
